export enum PetAnimations {
    IDLE = 'idle',
    IDLE_CLICK = 'idle_click',
    IDLE_CLICK_2 = 'idle_click_2',
    WALKING = 'walking',
    DIGGING = 'digging',
    IDLE_TO_WALKING = 'idleToWalking',
    WALKING_TO_IDLE = 'walkingToIdle',
    MINI_GAME_HUNGRY = 'miniGameHungry',
    MINI_GAME_FED = 'miniGameFed',
    HUNGRY = 'hungry',
    FALLING_ASLEEP = 'falling_asleep',
    SLEEPING = 'sleeping',
    AWAKENING = 'awakening',
}
